import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../../ui/dialog";
import { Button } from "../../ui/button";
import { FormField } from "../../shared/FormField";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../../ui/select";

export function NewRouteDialog({ open, onOpenChange, drivers, usedDriverIds, onCreate }) {
  const [driverId, setDriverId] = useState("");

  useEffect(() => { if (open) setDriverId(""); }, [open]);

  const available = drivers.filter((d) => !usedDriverIds.includes(d.id));

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="new-route-dialog">
        <DialogHeader>
          <DialogTitle>Select Driver for New Route</DialogTitle>
          <DialogDescription>Pick the active driver who will run this route. You'll draw its territory on the map next.</DialogDescription>
        </DialogHeader>
        <FormField label="Active Driver" required testId="new-route-driver-field">
          <Select value={driverId} onValueChange={setDriverId}>
            <SelectTrigger data-testid="new-route-driver-select"><SelectValue placeholder="Select a driver..." /></SelectTrigger>
            <SelectContent>
              {available.map((d) => (
                <SelectItem key={d.id} value={String(d.id)}>#{d.id} — {d.name} {d.phone ? `(${d.phone})` : ""}{d.address ? ` — ${d.address}` : ""}</SelectItem>
              ))}
              {available.length === 0 && <SelectItem value="none" disabled>No more active drivers available</SelectItem>}
            </SelectContent>
          </Select>
        </FormField>
        <DialogFooter>
          <Button variant="secondary" onClick={() => onOpenChange(false)} data-testid="new-route-cancel-button">Cancel</Button>
          <Button
            variant="accent" disabled={!driverId || driverId === "none"}
            onClick={() => { onCreate(Number(driverId)); onOpenChange(false); }}
            data-testid="new-route-confirm-button"
          >Create Route</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
